module.exports = __webpack_public_path__ + "static/img/million15.e0f9232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/million15.png
// module id = 1766
// module chunks = 5